// import React, { useState } from 'react';
// import { Nav } from 'react-bootstrap';
// import { Link } from "react-router-dom";
// const Footer = () => {
//   const [expanded, setExpanded] = useState(false);


//   const handleNavLinkClick = () => {
//     console.log("Before:", expanded);
//     setExpanded(false);
//     console.log("After:", expanded);
//   };
//   return (
//     <div style={{ 
//       display: 'flex', 
//       justifyContent: 'center', 
//       alignItems: 'center', 
//       backgroundColor: 'var(--black)', 
//       color: 'white', 
//       height: '90px', // Adjust the height as needed,
//       marginTop:"2rem"
//     }}>
//       <span style={{ marginRight: '10px' }}>
//       <Nav.Link as={Link} to="/work" onClick={handleNavLinkClick}>
//               My Work
//             </Nav.Link>
//       </span>
//       <span style={{ marginRight: '10px' }}>|</span>
//       <span style={{ marginRight: '10px' }}>
//       <Nav.Link as={Link} to="/aboutme" onClick={handleNavLinkClick}>
//                     About Me
//             </Nav.Link>
//       </span>
//       <span style={{ marginRight: '10px' }}>|</span>
//       <span>
//       <a href="https://www.linkedin.com/in/sajahkhan" target="_blank" rel="noopener noreferrer" style={{color:"white"}}>
//     LinkedIn
//     </a>
//       </span>
//     </div>
//   );
// }

// export default Footer;


// Footer.js
import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Footer = () => {
  const [expanded, setExpanded] = useState(false);

  const handleNavLinkClick = () => {
    console.log("Before:", expanded);
    setExpanded(false);
    console.log("After:", expanded);
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      backgroundColor: 'var(--primary)', 
      color: 'white', 
      height: '90px', // Adjust the height as needed
      marginTop: "2rem"
    }}>
      <span style={{ marginRight: '10px' }}>
        <Nav.Link as={Link} to="/work" onClick={handleNavLinkClick}>
          My Work
        </Nav.Link>
      </span>
      <span style={{ marginRight: '10px' }}>|</span>
      <span style={{ marginRight: '10px' }}>
        <Nav.Link as={Link} to="/aboutme" onClick={handleNavLinkClick}>
          About Me
        </Nav.Link>
      </span>
      <span style={{ marginRight: '10px' }}>|</span>
      <span>
        <a href="https://www.linkedin.com/in/kashaf-abdullah-482246207/" target="_blank" rel="noopener noreferrer" style={{ color: "white" }}>
          LinkedIn
        </a>
      </span>
    </div>
  );
}

export default Footer;
